enum ShippingType {
    EMS = "EMS",

    POST = "POST",

    SELF_PICKUP = "SELF_PICKUP",

    INTRA_CITY = "INTRA_CITY",

    JD_FULFILLMENT = "JD_FULFILLMENT",

    EXPRESS = "EXPRESS",

    FREE = "FREE",

    VIRTUAL = "VIRTUAL",
}

export default ShippingType;
